import type { DayPhase } from './types';

/** Dia: 6h–18h. Noite: 18h–6h. */
export function currentDayPhase(hour: number): DayPhase {
  return hour >= 6 && hour < 18 ? 'day' : 'night';
}

export function dayPhaseFromMs(ms: number): DayPhase {
  return currentDayPhase(new Date(ms).getHours());
}
